import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function useServiceAccountFormUpsert() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  interface SerivceAccountResponse {
    message?: string;
  }

  interface ServiceAccountData {
    title: string;
  }

  return useMutation({
    mutationFn: async (objectData: ServiceAccountData): Promise<SerivceAccountResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/create_service_account`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(objectData),
        }
      );
      const data = await response.json();

      if (!response.ok || (typeof data.code === 'number' && data.code >= 400)) {
        throw new Error(data.message || 'Failed to create service account');
      }

      return {
        message: data.message,
      };
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([
        'objectForm'
      ]);

      queryClient.invalidateQueries(['userOrganisationUsers']);
    },
  });
}
